import './Menu.css'
import React, { useState } from 'react'
import Sidebar from '../../Components/SideBar/index'
import ScrollToTop from '../../Components/ScrollToTop'
import Index2 from '../../Components/Navbar2/index2'
import Footer from '../../Components/Footer/Footer'
import InfoSection3 from '../../Components/Infosection3/Index3'
import { homeObjOne3 } from '../../Components/Infosection3/Data3'

const Lunch = () => {
  const [isOpen, setIsOpen] = useState(false)
      
     const toggle = () => {
      setIsOpen(!isOpen)
     }
  return (
    <>
      <ScrollToTop />
      <div className='HeroContainer_menu'>
        <Sidebar isOpen={isOpen} toggle={toggle}/>
        <div className='Hero_menu'>
          <Index2 toggle={toggle}/>
        </div>
      </div>
      <InfoSection3 {...homeObjOne3}/>
      <div className='menu_con'>
        <div className='menu_title'>
          Vår Meny
        </div>
      </div>
      <div className='menu'>
        <div className='menu_pic'>
          <div className='grid-container'>
            <div className='menu_t'>
              <div className='menu1'>
                <div className='menu1_title'>
                  Classic Lunch – 159 kr/person
                </div>
                  <br /><br />
                  <div className='menu1_mat'>
                    Varmrätt, sallad, bröd & dryck.
                  </div>
              </div>
              <div className='menu1'>
                <div className='menu1_title'>
                  Premium Lunch – 179 kr/person
                </div>
                <br /><br />
                <div className='menu1_mat'>
                  Premiumvarmrätt, två sallader, bröd & dryck.
                </div>
              </div>
              <div className='menu1'>
                <div className='menu1_title'>
                  Luxury Lunch – 219 kr/person
                </div>
                <br /><br />
                <div className='menu1_mat'>
                  Premiumvarmrätt, sallad, tillbehör, bröd, dessert & dryck.
                </div>
              </div>
            </div>
            <div className='card_con'>
                <div className='wrapper'>
                <br /><br />
                    <div className='card_area'>
                    <div className='card'>
                    <div className='meny_title'>
                        LUNCH
                        </div><br /><br />
                        <div className='menu_mat'>
                            Kyckling med ris & örtsås.
                            <br /><br />
                            Lax med potatis & citronsås.
                            <br /><br />
                            Pasta med kyckling & pesto.
                            <br /><br />
                            Lasagne med sallad.
                            <br /><br />
                            Thai chicken med jasminris.
                            <br /><br />
                            Teriyaki chicken med ris.
                            <br /><br />
                            Libanesisk kyckling med ris.
                            <br /><br />
                            Grekisk kyckling med citronpotatis.
                            <br /><br />
                            Vegetarisk curry.
                            <br /><br />
                            Poké Bowl.
                            <br /><br />
                        </div>
                        </div>
                        <div className='card'>
                        <div className='meny_title'>
                            SALLADER & BOWLS
                        </div><br /><br />
                        <div className='menu_mat'>
                            Grekisk sallad – 119 kr
                            <br /><br />
                            Quinoasallad – 119 kr
                            <br /><br />
                            Vegansk Buddha Bowl – 129 kr
                            <br /><br />
                            Kyckling Caesar – 139 kr
                            <br /><br />
                            Kyckling, fetaost & bulgur – 139 kr
                            <br /><br />
                            Poké Bowl med kyckling – 149 kr
                            <br /><br />
                            Räksallad – 159 kr
                            <br /><br />
                            Poké Bowl med lax – 169 kr
                            <br /><br />
                            Lax & avokado – 179 kr
                            <br /><br />
                        </div>
                        </div>
                        <div className='card'>
                        <div className='meny_title'>
                            FIKA
                        </div><br /><br />
                        <div className='menu_mat'>
                            Kanelbulle – 35 kr
                            <br /><br />
                            Kardemummabulle – 35 kr
                            <br /><br />
                            Croissant – 39 kr
                            <br /><br />
                            Muffin – 35 kr
                            <br /><br />
                            Cookie – 30 kr
                            <br /><br />
                            Brownie – 39 kr
                            <br /><br />
                            Morotskaka – 39 kr
                            <br /><br />
                            Frukt – 35 kr
                            <br /><br />
                            Fruktsallad – 49 kr
                            <br /><br />
                            Mini-bakverk – 45 kr
                            <br /><br />
                        </div>
                        </div>
                         <div className='card'>
                            <div className='meny_title'>
                                DRYCK
                            </div><br /><br />
                        <div className='menu_mat'>
                            Kaffe – 25 kr/person
                            <br /><br />
                            Te – 25 kr/person
                            <br /><br />
                            Juice – 25 kr/person
                            <br /><br />
                            Smoothie – 39 kr/person
                            <br /><br />
                            Mineralvatten – 20 kr/person
                            <br /><br />
                            Läsk – 25 kr/person
                            <br /><br />
                        </div>
                        </div>
                  </div>             
                </div>
              </div>
            </div>
          </div>
        </div>
      <Footer />
    </>
  )
}

export default Lunch